import apiClient from "./apiClient";

// دریافت لیست لایسنس‌های پارتیشن
export const getPartitionLicenses = async () => {
  try {
    const { data } = await apiClient.post(
      "/DS/admin_center/get_partition_license_header.zjs"
    );
    return Array.isArray(data) ? data : [];
  } catch (error) {
    const errData = error.response?.data;
    throw errData || { error: "Fetch licenses failed", details: error.message };
  }
};

// دریافت جزئیات یک لایسنس واقعی
export const getLicenseDetail = async (partition_license_id) => {
  const Req = {
    partition_licenses_id: partition_license_id
  };

  try {
    const { data } = await apiClient.post(
      "/DS/admin_center/get_partition_license_detail.zjs",
      Req
    );

    const result = Array.isArray(data) ? data[0] : data;
    return result;
  } catch (error) {
    const errData = error.response?.data;
    throw errData || { error: "Fetch license detail failed", details: error.message };
  }
};

export const calculateLicensePrice = async (payload) => {
  try {
    const response = await apiClient.post(
      "/DS/admin_center/calculate_license_price.zjs",
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Calculate License Price Error:", error);
    throw new Error(
      error?.response?.data?.message ||
      error?.message ||
      "Failed to calculate license price."
    );
  }
};
;
export const createLicenseRequest = async (parameters) => {
  try {
    const payload = {
      license_parameters_json: JSON.stringify(parameters),
    };

    const response = await apiClient.post(`/DS/admin_center/create_license_request.zjs`, payload);
    return response.data;
  } catch (error) {
    console.error("Create License Request Error:", error);
    throw new Error(
      error?.response?.data?.message ||
      error?.message ||
      "Failed to submit license request."
    );
  }
};
export const convertProformaToInvoice = async (proformaInvoiceId) => {
  try {
    const payload = {
      proforma_invoice_id: String(proformaInvoiceId),
    };

    const response = await apiClient.post(`/DS/admin_center/convert_proforma_to_invoice.zjs`, payload);
    return response.data;
  } catch (error) {
    console.error("Generate Payment Bill Error:", error);
    throw new Error(
      error?.response?.data?.message ||
      error?.message ||
      "Failed to generate payment bill."
    );
  }
};
export const payBill = async (paymentNumber, paymentMethod = "credit_card") => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      // شبیه‌سازی موفقیت تراکنش در سرور
      resolve([
        {
          STATUS: "SUCCESS",
          ERROR_NUMBER: 0,
          ERROR_MESSAGE: null,
          PAYMENT_NUMBER: paymentNumber,
          TRANSACTION_ID: `TXN_${Math.random().toString(36).substr(2, 9).toUpperCase()}`,
        }
      ]);
    }, 1000);
  });
};